import ErrorImg from "../assets/ErrorImg.svg"
import Navbar from "../components/Layout/Navbar"
import Button from "../components/Shared/Button"
import { useNavigate } from "react-router-dom"
const Error = () => {
    const navigate = useNavigate()
    return (
        <>
        <Navbar/>
                <div className='h-screen lg:container lg:pt-[118px] lg:pb-10'>
            <div className="bg-primary/20 h-full w-full flex md:flex-row flex-col items-center sm:justify-start justify-center lg:px-10 px-4">
                <div className="lg:max-w-[437px] sm:max-w-[370px] max-w-[325px] text-burntBlack md:pt-0 sm:pt-32 sm:text-start text-center">
                    <h1 className="font-bold lg:text-[64px] sm:text-5xl text-28px leading-none lg:mb-7 sm:mb-3">Ooops...</h1>
                    <p className="lg:text-[56px] sm:text-4xl text-2xl font-light sm:mb-8 mb-5 leading-none">Page Not Found</p>
                    <p className="sm:text-lg font-semibold mb-5 sm:mb-8">Sorry. the content you’re looking for doesn’t exist.
                        Either it was removed, or you mistyped the link. </p>
                    <Button onClick={() => { navigate(-1) }} className="sm:w-[380px] w-full sm:!h-16 !h-[54px]" variant="primary" >Go Back</Button>
                </div>
                <div>
                    <img src={ErrorImg} alt="Error" />
                </div>
                <div className="flex flex-col sm:justify-between sm:gap-0 gap-10 sm:h-full lg:static absolute right-0 lg:pt-0 pt-20 sm:bottom-auto bottom-20">
                    <h1 className="sm:text-[200px] text-[100px] text-white leading-none">4</h1>
                    <h1 className="sm:text-[200px] text-[100px] text-white leading-none">0</h1>
                    <h1 className="sm:text-[200px] text-[100px] text-white leading-none">4</h1>
                </div>
            </div>
        </div>
</>
    )
}

export default Error